import reduxFetch from 'react-redux-fetch';
import apiRoutes from '../../../../app/api/routes';
import { LINK_IDENTITY_RESOURCE, PRINCIPAL_RESOURCE } from '../../constants';
import { createErrorMessage } from '../../../app/helpers/createErrorMessage';

const LinkIdentityService = ComposedComponent =>
  reduxFetch([
    {
      resource: LINK_IDENTITY_RESOURCE,
      method: 'post',
      request: (principalId, body, callback, t) => ({
        url: apiRoutes.principalIdentity(principalId),
        body,
        meta: {
          callback,
          setOther: {
            resource: PRINCIPAL_RESOURCE,
          },
          toaster: {
            onErrorMessage: createErrorMessage(t, 'linkIdentityFailed'),
            onSuccessMessage: t('linkIdentitySuccess'),
          },
        },
      }),
    },
  ])(ComposedComponent);

export default LinkIdentityService;
